module.exports = __webpack_public_path__ + "static/media/platinesw.c290899a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platinesw.png
// module id = 257
// module chunks = 0